import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import { Button, Stack } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { route } from '../../route/Index';
import Span from '../../shared/component/Span';
import { cleanAlert } from '../../store/alert/alertSlice';
import { useAppDispatch } from '../../store/hook';
import { cleanProject } from '../../store/project/projectSlice';
import { cleanResult } from '../../store/result/resultSlice';
import { cleanImage } from '../../store/Image/imageSlice';

interface INewProps {}

const New = (props: INewProps) => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();

    const { t } = useTranslation();

    const handleClick = () => {
        dispatch(cleanProject());
        dispatch(cleanResult());
        dispatch(cleanImage());
        dispatch(cleanAlert());
        navigate(route.info);
    };

    return (
        <Stack>
            <Button variant='greenLight' startIcon={<AddCircleOutlineIcon />} onClick={handleClick}>
                <Span text={t('new')} />
            </Button>
        </Stack>
    );
};

export default New;
